// extracted by css-extract-rspack-plugin
export default {"originalPrice":"_950de6ec"};